import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'dda-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeedbackComponent implements OnInit {


  pages = [
    { nameKey: 'Community Hall Rating', url: 'http://ddaservices.dda.org.in/hallrating/' },
    { nameKey: 'Feedback Sports Complex', url: 'http://ddaservices.dda.org.in/fgs/memberhome.aspx' },
    { nameKey: 'Feedback On DDA Housing 2017', url: 'http://ddaservices.dda.org.in/feedback_test/allottelogin.aspx' },
    { nameKey: 'Feedback On DDA Housing 2014', url: 'http://ddaservices.dda.org.in/housingnew/allottelogin.aspx' },
    { nameKey: 'Feedback On Golf Course of DDA', url: 'http://ddaservices.dda.org.in/fgs/memberhome.aspx' },
    { nameKey: 'Feedback On Park Maintenance of DDA', url: 'http://ddaservices.dda.org.in/crmdp/home.aspx' }
  ];

  constructor() { }

  ngOnInit(): void {

    
  }

}
